// API base URL configuration
const getBaseUrl = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    if (apiUrl) {
        return apiUrl.replace(/\/$/, '');
    }
    // Production: Apache proxies /api to the backend on the same host
    if (process.env.NODE_ENV === 'production') {
        return '/api';
    }
    // Development: use same-origin paths (set REACT_APP_API_URL if API is on another host/port)
    return '';
};
export const API_BASE_URL = getBaseUrl();

// Helper function for API calls
export const fetchApi = async (endpoint, options = {}) => {
    // Remove /api prefix from endpoint if it exists and API_BASE_URL already contains /api
    const cleanEndpoint = endpoint.startsWith('/api/') && API_BASE_URL.includes('/api') 
        ? endpoint.substring(4) 
        : endpoint;
    
    const url = `${API_BASE_URL}${cleanEndpoint.startsWith('/') ? cleanEndpoint : `/${cleanEndpoint}`}`;

    // For FormData requests, don't set Content-Type header
    const headers = options.body instanceof FormData
        ? options.headers
        : {
            'Content-Type': 'application/json',
            ...options.headers,
        };

    const response = await fetch(url, {
        ...options,
        headers,
        credentials: 'include', // Include credentials for CORS
    });

    if (!response.ok) {
        // Try to get error message from response
        let message = `HTTP error! status: ${response.status}`;
        try {
            const errorData = await response.json();
            if (errorData.error) message = errorData.error;
        } catch (e) {
            // Non-JSON error body; keep the status message
        }
        const error = new Error(message);
        error.status = response.status;
        throw error;
    }

    return response.json();
}; 